<script setup lang="ts">
</script>
<template>
  <RuesBoxSize :size="props.item?.width">
    <div v-show="props.skeleton" class="h-full overflow-hidden rounded-xl border border-neutral-100">
      <div class="h-[220px] bg-neutral-100 animate-pulse" />
      <div class="flex flex-col  gap-y-2 px-5 py-3 h-full grow animate-pulse">
        <div class="flex flex-col gap-3 h-full">
          <div class="flex flex-col gap-y-px">
            <div class="rounded-xl max-w-[100px] h-[16px] bg-neutral-100" />
            <div class="rounded-xl max-w-[250px] h-[21px] bg-neutral-100" />
            <div class="rounded-xl max-w-[175px] h-[16px] bg-neutral-100" />
          </div>
          <div class="flex flex-row justify-between border-t border-neutral-100 pt-2 mt-2 w-full">
            <div>
              <div class="rounded-xl w-[100px] h-[20px] bg-neutral-100" />
            </div>
            <div>
              <div class="rounded-xl w-[100px] h-[23px] bg-neutral-100" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <SharedCard v-if="!props.skeleton" design="card" :href="props.item?.angebot?.url">
      <template #img>
        <img
          loading="lazy"
          :src="props.item?.angebot?.thumb"
          :alt="'Lastminute' + props.item?.angebot?.ort"
          height="220px"
          width="405px"
          :class="['h-[220px] object-cover object-center w-full bg-neutral-100' ]"
        >
        <div
          class="absolute top-3.5 left-2.5 bg-cta-50 text-cta-800 rounded-[4px] text-sm py-0.5 px-2 z-10"
        >
          <span>{{ props.item?.angebot?.prozent_ersparnis }}%</span>
          <UiLanguagePlaceholder domain="RuesCardLastminute" name="discount" />!
        </div>
      </template>
      <template #text>
        <div class="grid gap-3 h-full">
          <div class="flex flex-col gap-0.5 mb-3 text-sm text-neutral-600">
            <div>
              <UiIcon src="/svg/icons/location.svg" height="12px" width="12px" class="fill-neutral-600 -mt-px inline-block" />
              {{ props.item?.angebot?.ort }}
            </div>
            <div class="text-lg font-semibold text-neutral-900 leading-5 line-clamp-2 mb-0.5">
              {{ props.item?.angebot?.hausname }}
            </div>
            <div>
              <UiLanguagePlaceholder
                domain="RuesCardLastminute"
                name="date"
                :variables="{ start: vonDate, end: bisDate }"
              />
            </div>
          </div>
          <div class="flex flex-row justify-between gap-2 items-center border-t border-neutral-100 pt-2 mt-2">
            <div class="text-lg text-neutral-900 font-semibold">
              <UiLanguagePlaceholder domain="RuesCardLastminute" name="lastminute_deal" />
            </div>
            <div class="text-sm text-neutral-600">
              <UiLanguagePlaceholder domain="RuesCardLastminute" name="from" />
              <span class="font-semibold text-neutral-900 text-xl ml-0.5">{{ props.item?.angebot?.tagespreis }} €</span>
              <UiLanguagePlaceholder domain="RuesCardLastminute" name="night" />
            </div>
          </div>
        </div>
      </template>
    </SharedCard>
  </RuesBoxSize>
</template>

<script setup>
const props = defineProps({
  skeleton: {
    type: Boolean,
    default: true
  },
  item: {
    type: Object,
    default: null
  }
})

function formatDate (timestamp) {
  if (!timestamp) {
    return ''
  }
  const date = new Date(timestamp * 1000)
  let day = date.getDate()
  let month = date.getMonth() + 1
  if (day < 10) {
    day = '0' + day
  }
  if (month < 10) {
    month = '0' + month
  }
  return `${day}.${month}.`
}
const vonDate = formatDate(props.item?.angebot?.zeitraumvon?.timestamp)
const bisDate = formatDate(props.item?.angebot?.zeitraumbis?.timestamp)
</script>

